document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".subscription-plan-block") || document.querySelector(".subscriptionplansblock")) {
        import(/* webpackChunkName: "subscriptions" */ "/Features/SubscriptionPlans/js/subscriptions.js").then((module) => {
            const subscriptions = new module.default();
            subscriptions.init();
        });
    }
});
